import React from 'react';
import styles from './ui.module.css';
import Icon from './Icon';

interface PlaceholderProps {
  /** 'loading' shows a spinner; 'empty' shows a mark and the message. */
  kind?: 'empty' | 'loading';
  message?: React.ReactNode;
  /** Second line — usually what to do about it. */
  hint?: React.ReactNode;
  action?: React.ReactNode;
  /** A single line inside a small section, instead of filling the card. */
  compact?: boolean;
}

/**
 * What a card shows instead of rows. It fills the card rather than collapsing
 * it, so an empty result does not change the page's shape.
 */
const Placeholder: React.FC<PlaceholderProps> = ({ kind = 'empty', message, hint, action, compact = false }) => (
  <div
    className={`${styles.placeholder}${compact ? ` ${styles.placeholderCompact}` : ''}`}
    role={kind === 'loading' ? 'status' : undefined}
    aria-busy={kind === 'loading' || undefined}
  >
    {kind === 'loading' ? (
      <div className={styles.spinner} />
    ) : compact ? null : (
      <span className={styles.placeholderMark}>
        <Icon name="inbox" size={20} />
      </span>
    )}
    <span>{message ?? (kind === 'loading' ? 'Loading…' : 'Nothing to show here.')}</span>
    {hint && <span className={styles.placeholderHint}>{hint}</span>}
    {action}
  </div>
);

export default Placeholder;
